'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var lp = require('it-length-prefixed');

var itPipe = require('it-pipe');

var MulticodecTopology = require('libp2p-interfaces/src/topology/multicodec-topology.js');

var index$1 = require('./message/index.js');

var constants = require('./constants.js');

var index = require('./utils/index.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var lp__default = /*#__PURE__*/_interopDefaultLegacy(lp);

var MulticodecTopology__default = /*#__PURE__*/_interopDefaultLegacy(MulticodecTopology);

var BITSWAP100 = '/ipfs/bitswap/1.0.0';
var BITSWAP110 = '/ipfs/bitswap/1.1.0';
var BITSWAP120 = '/ipfs/bitswap/1.2.0';

var Network = /*#__PURE__*/function () {
  function Network(libp2p, bitswap, stats) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Network);

    this._log = index.logger(libp2p.peerId, 'network');
    this._libp2p = libp2p;
    this._bitswap = bitswap;
    this._protocols = [BITSWAP100];

    if (!options.b100Only) {
      this._protocols.unshift(BITSWAP110);

      this._protocols.unshift(BITSWAP120);
    }

    this._stats = stats;
    this._running = false;
    this._onPeerConnect = this._onPeerConnect.bind(this);
    this._onPeerDisconnect = this._onPeerDisconnect.bind(this);
    this._onConnection = this._onConnection.bind(this);
    this._hashLoader = options.hashLoader;
  }

  _createClass(Network, [{
    key: "start",
    value: function start() {
      this._running = true;

      this._libp2p.handle(this._protocols, this._onConnection);

      var topology = new MulticodecTopology__default["default"]({
        multicodecs: this._protocols,
        handlers: {
          onConnect: this._onPeerConnect,
          onDisconnect: this._onPeerDisconnect
        }
      });
      this._registrarId = this._libp2p.registrar.register(topology);

      var _iterator3 = _createForOfIteratorHelper(this._libp2p.peerStore.peers.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var peer = _step3.value;

          var conn = this._libp2p.connectionManager.get(peer.id);

          conn && this._onPeerConnect(conn.remotePeer);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this._running = false;

      this._libp2p.unhandle(this._protocols);

      if (this._registrarId != null) {
        this._libp2p.registrar.unregister(this._registrarId);
      }
    }
  }, {
    key: "_onConnection",
    value: function () {
      var _onConnection2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var _this = this;

        var protocol, stream, connection;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                protocol = _ref.protocol, stream = _ref.stream, connection = _ref.connection;

                if (this._running) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this._log('incoming new bitswap %s connection from %s', protocol, connection.remotePeer.toB58String());

                _context2.prev = 4;
                _context2.next = 7;
                return itPipe.pipe(stream, lp__default["default"].decode(), /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, data, message;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _iteratorAbruptCompletion = false;
                            _didIteratorError = false;
                            _context.prev = 2;
                            _iterator = _asyncIterator(source);

                          case 4:
                            _context.next = 6;
                            return _iterator.next();

                          case 6:
                            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                              _context.next = 23;
                              break;
                            }

                            data = _step.value;
                            _context.prev = 8;
                            _context.next = 11;
                            return index$1.BitswapMessage.deserialize(data.slice(), _this._hashLoader);

                          case 11:
                            message = _context.sent;
                            _context.next = 14;
                            return _this._bitswap._receiveMessage(connection.remotePeer, message);

                          case 14:
                            _context.next = 20;
                            break;

                          case 16:
                            _context.prev = 16;
                            _context.t0 = _context["catch"](8);

                            _this._bitswap._receiveError(_context.t0);

                            return _context.abrupt("break", 23);

                          case 20:
                            _iteratorAbruptCompletion = false;
                            _context.next = 4;
                            break;

                          case 23:
                            _context.next = 29;
                            break;

                          case 25:
                            _context.prev = 25;
                            _context.t1 = _context["catch"](2);
                            _didIteratorError = true;
                            _iteratorError = _context.t1;

                          case 29:
                            _context.prev = 29;
                            _context.prev = 30;

                            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                              _context.next = 34;
                              break;
                            }

                            _context.next = 34;
                            return _iterator.return();

                          case 34:
                            _context.prev = 34;

                            if (!_didIteratorError) {
                              _context.next = 37;
                              break;
                            }

                            throw _iteratorError;

                          case 37:
                            return _context.finish(34);

                          case 38:
                            return _context.finish(29);

                          case 39:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 25, 29, 39], [8, 16], [30,, 34, 38]]);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);

                this._log(_context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function _onConnection(_x) {
        return _onConnection2.apply(this, arguments);
      }

      return _onConnection;
    }()
  }, {
    key: "_onPeerConnect",
    value: function _onPeerConnect(peerId) {
      this._bitswap._onPeerConnected(peerId);
    }
  }, {
    key: "_onPeerDisconnect",
    value: function _onPeerDisconnect(peerId) {
      this._bitswap._onPeerDisconnected(peerId);
    }
  }, {
    key: "findProviders",
    value: function findProviders(cid, maxProviders) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this._libp2p.contentRouting.findProviders(cid, {
        timeout: constants.providerRequestTimeout,
        maxNumProviders: maxProviders
      });
    }
  }, {
    key: "findAndConnect",
    value: function () {
      var _findAndConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid, options) {
        var _this2 = this;

        var connectAttempts, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, provider;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                connectAttempts = [];
                _iteratorAbruptCompletion2 = false;
                _didIteratorError2 = false;
                _context3.prev = 3;
                _iterator2 = _asyncIterator(this.findProviders(cid, constants.maxProvidersPerRequest, options));

              case 5:
                _context3.next = 7;
                return _iterator2.next();

              case 7:
                if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
                  _context3.next = 14;
                  break;
                }

                provider = _step2.value;

                this._log("connecting to provider ".concat(provider.id));

                connectAttempts.push(this.connectTo(provider.id, options).catch(function (err) {
                  _this2._log.error(err);
                }));

              case 11:
                _iteratorAbruptCompletion2 = false;
                _context3.next = 5;
                break;

              case 14:
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 20:
                _context3.prev = 20;
                _context3.prev = 21;

                if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 25;
                return _iterator2.return();

              case 25:
                _context3.prev = 25;

                if (!_didIteratorError2) {
                  _context3.next = 28;
                  break;
                }

                throw _iteratorError2;

              case 28:
                return _context3.finish(25);

              case 29:
                return _context3.finish(20);

              case 30:
                _context3.next = 32;
                return Promise.all(connectAttempts);

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 16, 20, 30], [21,, 25, 29]]);
      }));

      function findAndConnect(_x3, _x4) {
        return _findAndConnect.apply(this, arguments);
      }

      return findAndConnect;
    }()
  }, {
    key: "provide",
    value: function () {
      var _provide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid, options) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._libp2p.contentRouting.provide(cid, options);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function provide(_x5, _x6) {
        return _provide.apply(this, arguments);
      }

      return provide;
    }()
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(peer, msg) {
        var stringId, connection, _yield$connection$new, stream, protocol, serialized;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this._running) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('network isn\'t running');

              case 2:
                stringId = peer.toB58String();

                this._log('sendMessage to %s', stringId, msg);

                _context5.next = 6;
                return this._libp2p.dial(peer);

              case 6:
                connection = _context5.sent;
                _context5.next = 9;
                return connection.newStream([BITSWAP120, BITSWAP110, BITSWAP100]);

              case 9:
                _yield$connection$new = _context5.sent;
                stream = _yield$connection$new.stream;
                protocol = _yield$connection$new.protocol;
                _context5.t0 = protocol;
                _context5.next = _context5.t0 === BITSWAP100 ? 15 : _context5.t0 === BITSWAP110 ? 17 : _context5.t0 === BITSWAP120 ? 17 : 19;
                break;

              case 15:
                serialized = msg.serializeToBitswap100();
                return _context5.abrupt("break", 20);

              case 17:
                serialized = msg.serializeToBitswap110();
                return _context5.abrupt("break", 20);

              case 19:
                throw new Error('Unknown protocol: ' + protocol);

              case 20:
                writeMessage(stream, serialized, this._log);

                this._updateSentStats(peer, msg.blocks);

              case 22:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendMessage(_x7, _x8) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
  }, {
    key: "connectTo",
    value: function () {
      var _connectTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peer, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this._running) {
                  _context6.next = 2;
                  break;
                }

                throw new Error('network isn\'t running');

              case 2:
                return _context6.abrupt("return", this._libp2p.dial(peer, options));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function connectTo(_x9, _x10) {
        return _connectTo.apply(this, arguments);
      }

      return connectTo;
    }()
  }, {
    key: "_updateSentStats",
    value: function _updateSentStats(peer, blocks) {
      var peerId = peer.toB58String();

      if (this._stats) {
        var _iterator4 = _createForOfIteratorHelper(blocks.values()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var block = _step4.value;

            this._stats.push(peerId, 'dataSent', block.length);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this._stats.push(peerId, 'blocksSent', blocks.size);
      }
    }
  }]);

  return Network;
}();

function writeMessage(_x11, _x12, _x13) {
  return _writeMessage.apply(this, arguments);
}

function _writeMessage() {
  _writeMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(stream, msg, log) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return itPipe.pipe([msg], lp__default["default"].encode(), stream);

          case 3:
            _context7.next = 8;
            break;

          case 5:
            _context7.prev = 5;
            _context7.t0 = _context7["catch"](0);
            log(_context7.t0);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 5]]);
  }));
  return _writeMessage.apply(this, arguments);
}

exports.Network = Network;